$(function() {
  // var fitties = fitty('.tih-title-jumbo h2', {
  //   maxSize: 1024
  // });
  // $(window).on('load', function() {
  //   fitties.forEach(function(fitty1) {
  //     fitty1.fit();
  //   });
  // });

  // $('.tih-video-grid-box').on('mouseover', function(e) {
  //   var idx = $('.tih-video-grid-box').index($(this));
  //   var length = $('.tih-video-grid-box').length;
  //   var length_i = length - 1;
  //   var grid_css = '';
  //   var unhover_buffer = window.innerWidth >= 768 ? 80 : 56;
  //   var hover_buffer = (unhover_buffer * length_i) + (5 * length_i);
  //   for (var i = 0; i < length; i++) {
  //     grid_css += i==idx ? 'calc(100% - '+hover_buffer+'px) ' : unhover_buffer+'px '
  //   }
  //   $('.tih-video-grid').addClass('active').css({
  //     'grid-template-columns': grid_css,
  //   });

  //   $(this).addClass('active');

  //   $('video', this).each(function() {
  //     if ($(this).get(0).offsetParent !== null) {
  //       $(this).get(0).play();
  //     }
  //   });
  // }).on('mouseleave', function(e) {
  //   $('.tih-video-grid').removeClass('active').removeAttr('style');

  //   $(this).removeClass('active');

  //   $('.tih-video-grid video').each(function() {
  //     $(this).get(0).pause();
  //     $(this).get(0).currentTime = 0;
  //   });
  // });

  if ([
    'kef-staging-int.myshopify.com', 'kef-eu.myshopify.com', 
    'kef-staging-cn.myshopify.com', 'kef-cn.myshopify.com'
  ].indexOf(Shopify.shop) < 0) {
    $('.tih-event-upcoming').on('click', function() {
      $('#page-tih').trigger({
        type: 'click_tih-event-upcoming',
      });
      window.location.href = Shopify.routes.root+'pages/subscription';
    });
  } else {
    $('.tih-event-upcoming').css({
      'cursor': 'default',
    });
  }

  $('.tih-video-grid-box').on('click', function(e) {
    if (e.target.nodeName == 'A') return true;

    var _t = $(this);
    if (_t.hasClass('active')) return false;

    var idx = $('.tih-video-grid-box').index(_t);
    var length = $('.tih-video-grid-box').length;
    var length_i = length - 1;
    var grid_css = '';
    var unhover_buffer = window.innerWidth >= 768 ? 80 : 56;
    var hover_buffer = (unhover_buffer * length_i) + (5 * length_i);
    for (var i = 0; i < length; i++) {
      grid_css += i==idx ? 'calc(100% - '+hover_buffer+'px) ' : unhover_buffer+'px '
    }
    $('.tih-video-grid').addClass('active').css({
      'grid-template-columns': grid_css,
    });

    $('.tih-video-grid-box').removeClass('active');
    _t.addClass('active');

    $('.tih-video-grid .video-player').each(function() {
      var vid = $(this);
      video_player.pause(vid);
      // $(this).get(0).pause();
      // $(this).get(0).currentTime = 0;
    });
    $('.video-player', _t).each(function() {
      var vid = $(this);      
      if (vid.get(0).offsetParent !== null) {
        video_player.play(vid);
        setTimeout(function() { 
          resizeIframe(vid); 
        }, 600);
        // $(this).get(0).play();
        return false;
      }
    });
  });
  $('.tih-video-grid-box .tih-video-link').on('click', function(e) {
    return true;
  });
  $('.tih-video-grid-box .video-player-bg').on('click', function(e) {
    var vid = $(this);
    if (vid.parent('.video-player-box').hasClass('paused')) {
      video_player.play(vid);
    } else if (vid.parent('.tih-video-grid-box').hasClass('active')) {
      video_player.play(vid);
    }
  });
  $('.tih-video-grid-box .video-player').on('click', function(e) {
    var vid = $(this);
    if (vid.parent('.video-player-box').hasClass('playing')) {
      video_player.pause(vid);
    }
  });
  $(document).on('click', function(e) {
    var _target = $(e.target);
    var target = _target.parents('.tih-video-grid-box');
    if (target.length == 0) {
      $('.tih-video-grid').removeClass('active').removeAttr('style');

      $('.tih-video-grid-box').removeClass('active');
      
      $('.tih-video-grid .video-player').each(function() {
        video_player.pause($(this));
        // $(this).get(0).pause();
        // $(this).get(0).currentTime = 0;
      });
    }
  });

  video_player.init();

  $(window).on('resize', function() {
    resizeIframe($('.tih-video-grid-box.active .video-player'));
  });

  // zine
  tihUpdateZineImg();
  $(window).on('resize', tihUpdateZineImg);
  function tihUpdateZineImg() {
    if (document.body.clientWidth >= 1280) {
      $('.tih-event-zine').each(function() {
        $('.tih-event-img', this).css({
          minHeight: $('.tih-event-excerpt', this).get(0).clientHeight,
        });
      });
    } else {
      $('.tih-event-zine .tih-event-img').removeAttr('style');
    }
  }
});

function resizeIframe(_t) {
  var iframe = $('iframe', _t);
  if (iframe.length == 0) return;
  iframe.removeAttr('style');

  // postcard
  if (window.innerWidth >= 768) {
    // 6x8
    var h = _t.width() / 8 * 6 / _t.height();
    if (h > 1) {
      iframe.css({
        height: _t.width(),
      });
    } else {
      var w = _t.height() / 6 * 8 / _t.width();
      iframe.css({
        width: _t.height(),
      });
    }
  } else {
    // 3*2
    var h = _t.width() / 2 * 3 / _t.height();
    // console.log('4x5', h)
    if (h > 1) {
      iframe.css({
        height: `${h * 100}%`,
      });
    } else {
      var w = _t.height() / 3 * 2 / _t.width();
      // console.log('4x5', w)
      iframe.css({
        width: `${w * 100}%`,
      });
    }
  }
  return;

  // var box = _t.parents('.tih-video-grid-box');
  // if (box.hasClass('active')) return;
  
  // // single iframe
  // var h = _t.width() / 16 * 9 / _t.height();
  // if (h > 1) {
  //   iframe.css({
  //     height: `${h * 100}%`,
  //   });
  // } else {
  //   var w = _t.height() / 9 * 16 / _t.width();
  //   iframe.css({
  //     width: `${w * 100}%`,
  //   });
  // }

  // multi iframe
  // console.log(_t.width(), _t.height())
  if (window.innerWidth >= 1024) {
    // 16x9
    var h = _t.width() / 16 * 9 / _t.height();
    // console.log('16x9', h)
    if (h > 1) {
      iframe.css({
        height: `${h * 100}%`,
      });
    } else {
      var w = _t.height() / 9 * 16 / _t.width();
      // console.log('16x9', w)
      iframe.css({
        width: `${w * 100}%`,
      });
    }
  } else if (window.innerWidth >= 768) {
    // 1x1
    if (_t.width() > _t.height()) {
      // console.log('1x1', _t.width())
      iframe.css({
        height: _t.width(),
      });
    } else {
      // console.log('1x1', _t.height())
      var w = _t.height() / 5 / 4 / _t.width();
      iframe.css({
        width: _t.height(),
      });
    }
  } else {
    // 4x5
    var h = _t.width() / 4 * 5 / _t.height();
    // console.log('4x5', h)
    if (h > 1) {
      iframe.css({
        height: `${h * 100}%`,
      });
    } else {
      var w = _t.height() / 5 * 4 / _t.width();
      // console.log('4x5', w)
      iframe.css({
        width: `${w * 100}%`,
      });
    }
  }
}

$(function() {
  // if (location.pathname == '/pages/take-it-home') {
  //   $('.page-tih .tih-event-highlight').remove();
  // } else {
  //   $('.page-tih .tih-event-highlight').css({
  //     display: 'flex'
  //   });
  // }

  var tnc = $('.tih-event-excerpt a[href*="/pages/terms-and-conditions"]');
  if (tnc.length > 0) {
    tnc.attr('href', tnc.attr('href')+'#tih');
  }

  if (window.location.hash == '#register') {
    tihScrollToSsoForm();
  }
  if (window.location.hash == '#event') {
    tihScrollToEventHighlight();
  }

  $('.tih-event-cta-event, a[href="#event"]').on('click', function(e) {
    tihScrollToEventHighlight();
    e.preventDefault();
  });
  $('.tih-event-cta-mykef, .tih-event-excerpt .tih-event-listen, a[href="#register"]').on('click', function(e) {
    tihScrollToSsoForm();
    e.preventDefault();
  });
  function tihGetHeaderBuffer() {
    var header = $('#header-v3');
    if (header.length == 0) header = $('#header');

    var H = header.outerHeight();

    var sticky_menu = $('.tih-sticky-menu');
    if (sticky_menu.length > 0) H += sticky_menu.outerHeight();

    return H;
  }
  function tihScrollToEventIntro() {
    if ($('.tih-title-listen').length == 0) return;
    var scrollTop = $('.tih-title-listen').offset().top - tihGetHeaderBuffer();
    $('html, body').stop().animate({
      scrollTop: scrollTop < 0 ? 0 : scrollTop
    }, 300);
  }
  function tihScrollToEventHighlight() {
    if ($('.tih-event-highlight').length == 0) return;
    var scrollTop = $('.tih-event-highlight').offset().top - tihGetHeaderBuffer();
    $('html, body').stop().animate({
      scrollTop: scrollTop < 0 ? 0 : scrollTop
    }, 300);
  }
  function tihScrollToSsoForm() {
    if ($('.tih-sso').length == 0) return;
    var scrollTop =  $('.tih-sso').offset().top - tihGetHeaderBuffer();
    $('html, body').stop().animate({
      scrollTop: scrollTop < 0 ? 0 : scrollTop
    }, 300);
 
  }

  $('.page-tih .tih-events').prepend('<a name="highlight"></a>');
  $(".page-tih .tih-title-explore + .tih-intro + .tih-events").first().prepend("<a name='listenevents'></a>");

  $('.tih-banner .kef-bg').on('click', tihScrollToEventIntro);
  $('.tih-event-highlight').on('click', tihScrollToSsoForm);

  // if ([
  //   'kef-staging-int.myshopify.com', 
  //   'kef-staging-kr.myshopify.com', 
  //   'kef-staging-cn.myshopify.com', 
  //   'kef-eu.myshopify.com',
  //   'kef-kr.myshopify.com',
  //   'kef-cn.myshopify.com'
  // ].indexOf(Shopify.shop) < 0) {
  //   $('.page-tih .tih-sso').prepend('<a name="register"></a>');
  //   $('.page-tih .tih-event-cta-mykef').attr('href', '#register');
  //   $('.page-tih a[href*="/account"]').attr('href', global_fn.getSsoLink('tih_login')).attr('target', '_blank');

  //   var iframe_form = $('.page-tih .tih-sso-form iframe'),
  //       iframe_form_url = global_fn.getSsoLink('tih_register'),
  //       iframe_script_url = (new URL(iframe_form_url)).origin;
  //   $(`<script src="${iframe_script_url}/iframe-resize-helper.js"></script>`).insertAfter(iframe_form);
  //   iframe_form.attr('id', 'ksl-signup-form').attr('src', iframe_form_url);
  // } else {
  //   $('.page-tih .tih-sso').remove();
  // }
  $('.page-tih .tih-sso').remove();
});
window.addEventListener('message', function (event) {
  if (event.data.message === 'ACCOUNT_CREATED') {
    var ssoClass = 'tih-sso';
    var yOffset = -100; 
    var element = document.getElementsByClassName(ssoClass)[0];
    var y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({
      top: y, 
      behavior: 'smooth'
    });

    $('.page-tih .tih-sso-form iframe').addClass('registered');

    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'tih_account_created',
      });

      // seoul
      window.dataLayer.push({
        'event': 'mykef_tih_submit_form', 
        'city': 'seoul'
      });
    }

    $('#page-tih').trigger({
      type: 'account_created',
    });
  } else if (event.data.message === 'MYKEF_TIH_LOGIN') {
    if (typeof window.dataLayer !== 'undefined') {
      // seoul
      window.dataLayer.push({
        'event': 'mykef_tih_login', 
        'city': 'seoul'
      });
    }

    $('#page-tih').trigger({
      type: 'mykef_tih_login',
    });
  } else if (event.data.message === 'MYKEF_TIH_SOL') {
    if (typeof window.dataLayer !== 'undefined') {
      // seoul
      window.dataLayer.push({
        'event': 'mykef_tih_sol', 
        'city': 'seoul'
      });
    }

    $('#page-tih').trigger({
      type: 'mykef_tih_sol',
    });
  }
});